function isExternalUrl (url) {
  if (!url) return false
  const s = String(url).trim()
  return /^(https?:)?\/\//i.test(s) || /^mailto:/i.test(s) || /^tel:/i.test(s)
}

/**
 * Install global goUrl(url, options) for Vue2.
 *
 * Usage in template:
 *   @click="goUrl('/center/setting')"
 *
 * Usage in code:
 *   this.goUrl({ path: '/center', query: { a: 1 } })
 */
export default function installGoUrl (Vue) {
  if (!Vue || Vue.prototype.goUrl) return

  Vue.prototype.goUrl = function goUrl (to, options = {}) {
    if (to == null || to === '') return

    // external link
    if (typeof to === 'string' && isExternalUrl(to)) {
      const target = options.target || '_self'
      if (target === '_blank') {
        window.open(to, '_blank')
      } else {
        window.location.href = to
      }
      return
    }

    // vue-router navigation
    const router = this && this.$router
    if (!router) {
      if (typeof to === 'string') window.location.href = to
      return
    }

    let loc = to
    if (typeof to === 'string') {
      loc = options.query ? { path: to, query: options.query } : to
    }

    const nav = options.replace ? router.replace(loc) : router.push(loc)
    if (nav && typeof nav.catch === 'function') {
      nav.catch(() => {})
    }
  }
}





// WEBPACK FOOTER //
// ./src/utils/goUrl.js